import React from 'react'
import { useFeatures, FeaturesProps } from './useFeatures'
import styles from './Features.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'
import FeatureCard from 'components/FeatureCard/FeatureCard'

const Features: React.FC<FeaturesProps> = (props: FeaturesProps) => {
  const { features } = useFeatures(props)

  return (
    <section id='features' className={styles.features}>
      <TitleSection
        title='Features'
        descriptionTitle='Features'
        description='Everything you need to manage your restaurant menu online — customizable, user-friendly, and packed with smart features.'
      />

      <div className='container'>
        <div className='row gy-5'>
          {features.length ? (
            features.map((feature, i) => (
              <FeatureCard
                key={`landing-feature-${i}`}
                title={feature.title}
                description={feature.description}
                icon={feature.icon}
                isSoon={feature.isSoon}
              />
            ))
          ) : (
            <div style={{ color: 'var(--footer-color)' }}>
              Nothing Found Here!
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Features
